import { createFileRoute, Outlet } from '@tanstack/react-router';
import { AclRoute, EntityAclKeys, withPermission } from '@/lib/acl';

/**
 * Segment layout for `/entities` — gates the whole subtree (listing + detail +
 * `/entities/new`) behind `entities:listing:read` via a single gated Outlet. (ENT-89 T15.)
 */
export const Route = createFileRoute('/entities')({
  component: withPermission(Outlet, {
    key: EntityAclKeys.listingRead,
    route: AclRoute.ENTITY,
    resourceLabel: 'Entities',
  }),
});
